// cartManager.js
import { createContext, useState } from 'react';

export const CartContext = createContext([]);

export const CartProvider = ({ children }) => {
    let storedCart = JSON.parse(localStorage.getItem('cart')) ||[]; // Initialize cart from localStorage if available;
    const [items, setItems] = useState(storedCart); // Initialize cart items from
    


    return (
        <CartContext.Provider value={{ items, setItems}}>
            {children}
        </CartContext.Provider>
    );
};


